"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, use } from "react";
const ServerComponentContext = createContext({
    cache: new Map(),
    endpoint: "",
});
/*
 * A wrapper around ServerComponentContext.Provider. This is necessary to make
 * it a client component. Otherwise, rendering it in a server component will
 * error.
 */
const Provider = (({ value, ...props }) => {
    const parentContext = useServerComponentContext();
    return (_jsx(ServerComponentContext.Provider, { value: { ...parentContext, ...value }, ...props }));
});
export { Provider as ServerComponentContext };
export const useServerComponentContext = () => use(ServerComponentContext);
